import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, PRIMARY_OUTLET } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class BreadcrumbComponent implements OnInit {
  private readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';

  public breadcrumbs: Breadcrumb[];

  public constructor(private readonly _activatedRoute: ActivatedRoute, private readonly _router: Router) {
    this.breadcrumbs = [];
  }

  public ngOnInit() {
    if (this._router.navigated) {
      this.generateBreadcrumbTrail();
    }

    this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.generateBreadcrumbTrail();
    });
  }

  private generateBreadcrumbTrail() {
    this.breadcrumbs = [
      {
        label: 'breadcrumb.tableau-de-bord',
        url: '/'
      }
    ];

    let currentRoute: ActivatedRoute = this._activatedRoute.root;
    let url = '';

    while (currentRoute.children.length > 0) {
      const childrenRoutes: ActivatedRoute[] = currentRoute.children;
      let breadCrumbLabel = '';

      childrenRoutes.forEach(route => {
        currentRoute = route;

        if (route.outlet !== PRIMARY_OUTLET) {
          return;
        }

        const hasData = !!(
          route.snapshot &&
          route.snapshot.url.length > 0 &&
          route.snapshot.data &&
          route.snapshot.data[this.ROUTE_DATA_BREADCRUMB]
        );

        if (hasData) {
          breadCrumbLabel = route.snapshot.data[this.ROUTE_DATA_BREADCRUMB];

          const routeURL: string = route.snapshot.url.map(segment => segment.path).join('/');
          url += `/${routeURL}`;

          const breadcrumb: Breadcrumb = {
            label: breadCrumbLabel,
            url: url
          };

          this.breadcrumbs.push(breadcrumb);
        }
      });
    }
  }
}
